module.exports = __webpack_public_path__ + "img/others_06.a7e03a76.jpg";